import React from 'react';
import {trackError, ErrorType} from '@dazn/lp-web/src/utils/trackError';

export interface ErrorBoundaryProps {
    children: React.ReactNode;
}

interface ErrorBoundaryState {
    hasErrored: boolean;
}

export class ErrorBoundary extends React.PureComponent<
    ErrorBoundaryProps,
    ErrorBoundaryState
> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = {hasErrored: false};
    }

    public componentDidCatch(error: Error): void {
        trackError(error, {
            errorType: ErrorType.ReactErrorBoundary
        });
        this.handleError();
    }

    public render(): React.ReactNode {
        if (this.state.hasErrored) {
            return <div data-test-id="ERROR_BOUNDARY_FALLBACK" />;
        }

        return this.props.children;
    }

    private handleError = (): void => {
        this.setState({hasErrored: true});
    };
}
